// Module
var code = "<div :id=\"`editor-${uniqueId}`\" class=\"clear\" ref=\"editorEl\"> <div v-if=\"loading\" class=\"alignc\"> <loader :delay=\"100\"></loader> </div> <textarea :style=\"{ opacity: loading ? 0 : 1 }\" ref=\"textAreaEl\" v-model=\"pValue\" aria-label=\"code-editor\"></textarea> </div>";
// Exports
export default code;